import { call, put, takeLatest } from "redux-saga/effects";

import {
  FETCH_ATTENDEES_FOR_PERIOD,
  FETCH_ATTENDEE_STATISTICS_FOR_PERIOD,
  FETCH_EVENTS_FOR_ATTENDEE,
  FetchAttendeesForPeriodAction,
  FetchAttendeeStatisticsForPeriodAction,
  FetchEventsForAttendeeAction,
  fetchEventsForAttendeeState,
  setAttendeesStateAction,
  KnownAction,
} from "../actions/attendees.actions";

import { eventsApi } from "../../api";

const api = {
  getAttendeesForPeriod: (
    ...args: Parameters<typeof eventsApi.getAttendeesForPeriod>
  ) => eventsApi.getAttendeesForPeriod(...args),
  getAttendeeStatisticsForPeriod: (
    ...args: Parameters<typeof eventsApi.getAttendeeStatisticsForPeriod>
  ) => eventsApi.getAttendeeStatisticsForPeriod(...args),
  getEventsForAttendee: (
    ...args: Parameters<typeof eventsApi.getEventsForAttendee>
  ) => eventsApi.getEventsForAttendee(...args),
};

function* fetchAttendeesForPeriod(action: FetchAttendeesForPeriodAction) {
  const { period, filters } = action;

  yield put(setAttendeesStateAction("loading"));

  try {
    const { data } = yield call(api.getAttendeesForPeriod, {
      period,
      ...filters,
    });
    yield put<KnownAction>({ type: "SET_ATTENDEES", data });
  } catch (error) {
    yield put(setAttendeesStateAction("error"));
  }
}

function* fetchAttendeeStatisticsForPeriod(
  action: FetchAttendeeStatisticsForPeriodAction
) {
  const { period, filters } = action;
  try {
    const { data } = yield call(api.getAttendeeStatisticsForPeriod, {
      period,
      ...filters,
    });
    yield put<KnownAction>({ type: "SET_ATTENDEE_STATISTICS", data });
  } catch (error) {
  }
}

function* fetchEventsForAttendee(action: FetchEventsForAttendeeAction) {
  const { attendeeId, period } = action;
  yield put(fetchEventsForAttendeeState("loading"));
  try {
    const { data } = yield call(api.getEventsForAttendee, {
      attendeeId,
      period,
    });
    yield put<KnownAction>({ type: "SET_EVENTS_FOR_ATTENDEE", data });
  } catch (error) {
    yield put(fetchEventsForAttendeeState("error"));
  }
}

function* eventsSaga() {
  yield takeLatest(FETCH_ATTENDEES_FOR_PERIOD, fetchAttendeesForPeriod);
  yield takeLatest(
    FETCH_ATTENDEE_STATISTICS_FOR_PERIOD,
    fetchAttendeeStatisticsForPeriod
  );
  yield takeLatest(FETCH_EVENTS_FOR_ATTENDEE, fetchEventsForAttendee);
}

export default eventsSaga;
